import { Box, Button, Dialog, DialogContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core"
import { useEffect, useState } from "react";
import { DatePicker } from "../../../../components/DatePicker";
import { MyTimePicker } from "../../../../components/TimePicker";
import { getTranslation } from "../../../../heplers/translationHelper";
import ButtonWithLoading from "../../../../components/ButtonWithLoading";
import dayjs from "dayjs";
import { Create, Get } from "../../../../actions";
import { format } from "../../../../heplers/format";
import DialogComponent from "../../../../components/Dialog";
import { ShowCalendar } from "./components/showCalendar";
import { Post_GenerateAdhocMeetings_URL } from "../../../../constants/apiUrls";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";

export const PreviewMeetings=({initialValues,BackStep,currentStep})=>{
	const [openCalendar, setOpenCalendar] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
    const [possibleMeetings,setPossibleMeetings]=useState([])
    const [selectedPossibleMeeting,setSelectedPossibleMeeting]=useState(null)
    const {enqueueSnackbar}=useSnackbar()
	const history = useNavigate();

    const handleSubmit=async ()=>{
        setIsSubmitting(true)
      for (let index = 0; index < possibleMeetings.length; index++) {
        const payload = possibleMeetings[index];

        // Remove the id field from each guest in the Guesty array
        payload.guests = payload.guests.map((guest) => {
          const { id, ...guestWithoutId } = guest;
          return guestWithoutId;
        });
        payload.meetingDate = dayjs(payload.meetingDate).format(
          "MM-DD-YYYY hh:mm a"
        );
        payload.meetingTime = dayjs(payload.meetingTime).format(
          "MM-DD-YYYY hh:mm a"
        );
        payload.meetingDuration = dayjs(payload.meetingDuration).format(
          "MM-DD-YYYY hh:mm a"
        );
        await Create(
          {
            ...payload,
            enableDeleteDraft: index == possibleMeetings.length - 1,
          },
          Post_GenerateAdhocMeetings_URL,
          null,
          (resp) => {
            //   actions.setSubmitting(false);
            //   enqueueSnackbar(resp.data, {
            //     variant: "success",
            //   });
            // setRegularMeetingModel(initialValues);
            // setActiveStep(0);
          },
          (error) => {
            //   actions.setSubmitting(false);
            //   if (error.data?.message) {
            //     enqueueSnackbar(error.data?.message, {
            //       variant: "error",
            //     });
            //   } else
            //     enqueueSnackbar(error.data, {
            //       variant: "error",
            //     });
          }
        );
      }

      enqueueSnackbar(
        `${possibleMeetings.length} meetings has been created and notifications with calendar has been sent to all attendants.`,
        {
          variant: "success",
        }
      );
      setIsSubmitting(false)
      history("/meetings/"+initialValues.managementCompanyId+"/regular")
    }

    useEffect(async ()=>{
        if (currentStep == 8) {
          //  Find possible meetings
          let totalMeetingsPossible = 365 / initialValues.periodicity;
          let forYear = dayjs(initialValues.meetingDate).year();
          let meetingStartDate = dayjs(initialValues.meetingDate);
          let meetingsGenerated = [];

          for (let i = 1; i <= totalMeetingsPossible; i++) {
            // check current year ends
            if (forYear != dayjs(meetingStartDate).year()) break;
            
            await Create(
              { ...initialValues, meetingDate: meetingStartDate.format() },
              "Meeting/GetPossibleClashDetail",
              null,
              (resp) => {
                if(resp.data=="Ok")
                    meetingsGenerated.push({
                        ...initialValues,
                        meetingDate: meetingStartDate,
                      });
                      else
                      meetingsGenerated.push({
                        ...initialValues,
                        meetingDate: meetingStartDate,
                        hasClash:true,
                        clashedComments:resp.data
                      });
              },
              (error) => {}
            );
            meetingStartDate=meetingStartDate.add(initialValues.periodicity,'days')
            
          }
          setPossibleMeetings(meetingsGenerated)
          //   Create(
          //     initialValues,
          //     "Meeting/GetPossibleMeetings",
          //     null,
          //     resp=>{
          //         setPossibleMeetings(resp.data)
          //     },
          //     error=>{

          //     }
          //   )
        }
    },[currentStep])

    const getDayOfWeek=(meetingDate)=>{
        let day=dayjs(meetingDate).day();
        switch (day) {
            case 0:
                return "Sunday";
                break;
            case 1:
                return "Monday";
                break;
            case 2:
                return "Tuesday";
                break;
            case 3:
                return "Wednesday";
                break;
            case 4:
                return "Thursday";
                break;
            case 5:
                return "Friday";
                break;
            case 6:
                return "Saturday";
                break;
        
            default:
                break;
        }
    }

    const onUpdateMeeting=(meetingDate,meetingTime,meetingDuration)=>{
        var temp=possibleMeetings;
        var index=temp.findIndex(x=>x==selectedPossibleMeeting)
        var newMeeting={...selectedPossibleMeeting,meetingDate:meetingDate,meetingTime:meetingTime,meetingDuration:meetingDuration}
        temp[index]=newMeeting
        setPossibleMeetings([...temp])
        setSelectedPossibleMeeting(newMeeting)
    }

    const onMarkResolved=(meetingDate,meetingTime,meetingDuration)=>{
        var temp=possibleMeetings;
        var index=temp.findIndex(x=>x==selectedPossibleMeeting)
        var newMeeting={...selectedPossibleMeeting,meetingDate:meetingDate,meetingTime:meetingTime,meetingDuration:meetingDuration,hasClash:false,clashedComments:"Ok"}
        temp[index]=newMeeting
        setPossibleMeetings([...temp])
        setSelectedPossibleMeeting(null)
        setOpenCalendar(false)
    }

    return (
      <>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Start Time</TableCell>
                <TableCell>Duration Time</TableCell>
                <TableCell>Clash Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
                {possibleMeetings.map(meeting=> <TableRow>
                <TableCell>{format("date",meeting.meetingDate)} {getDayOfWeek(meeting.meetingDate)}</TableCell>
                <TableCell>{format("time",meeting.meetingTime)}</TableCell>
                <TableCell>{dayjs(meeting.meetingDuration).hour()} hours</TableCell>
                <TableCell>
                    {meeting.hasClash? 
                  <Typography style={{ color: "red" }}>{meeting.clashedComments}</Typography>:
                  <Typography style={{ color: "green" }}>Ok</Typography>}
                </TableCell>
                <TableCell>
                
                  <Button
                  variant="contained"
                  onClick={() => {
                    setSelectedPossibleMeeting(meeting)
                    setOpenCalendar(true)
                }}
                >
                  Show Calendar
                </Button>
               
                </TableCell>
              </TableRow>)}
              
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          mt={5}
          pr={1}
          pb={1}
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <ButtonWithLoading
            title={getTranslation("Generate", "produire", "Generieren")}
            size="medium"
            variant="contained"
            color="primary"
            loading={isSubmitting}
            //onClick={handleSubmit}
            disabled={possibleMeetings.findIndex(x=>x.hasClash)>=0}
            onClick={() => {
              handleSubmit();
            }}
          />
        </Box>

        <ShowCalendar open={openCalendar} onClose={()=>{
            setSelectedPossibleMeeting(null)
            setOpenCalendar(false)}} 
            possibleMeeting={selectedPossibleMeeting} 
            onUpdate={onUpdateMeeting}
            managementCompanyName={"CURRENT COMPANY - MEETING"}
            onMarkResolved={onMarkResolved}
            />
      </>
    );
}